<div class="row mt-5">
    <div class="col-md-12 ">
        <nav>
            <div class="nav nav-tabs nav-fill" id="nav-tab" role="tablist">

                <a class="nav-item nav-link" *ngIf="visibleTabs['vision']" [class.active]="activeTab === 'vision'"
                    (click)="switchTab('vision', 'nav-vision')" role="tab" aria-selected="false">
                    <i class="fas fa-eye fa-3x d-block"></i><span class="d-none d-sm-block">Vision</span>
                </a>
                <a class="nav-item nav-link" *ngIf="visibleTabs['lasik']" [class.active]="activeTab === 'lasik'"
                    (click)="switchTab('lasik', 'nav-lasik')" role="tab" aria-selected="false">
                    <i class="fas fa-low-vision fa-3x d-block"></i><span class="d-none d-sm-block">LASIK</span>
                </a>
                <a class="nav-item nav-link" *ngIf="visibleTabs['hearing']" [class.active]="activeTab === 'hearing'"
                    (click)="switchTab('hearing', 'nav-hearing')" role="tab" aria-selected="false">
                    <i class="fas fa-low-vision fa-3x d-block"></i><span class="d-none d-sm-block">Hearing</span>
                </a>
                <a class="nav-item nav-link" *ngIf="visibleTabs['urgentcare']" [class.active]="activeTab === 'urgentcare'"
                    (click)="switchTab('urgentcare', 'nav-urgentcare')" role="tab" aria-selected="false">
                    <i class="fas fa-prescription-bottle-alt fa-3x d-block"></i><span class="d-none d-sm-block">Urgent
                        Care</span>
                </a>
                <a class="nav-item nav-link" *ngIf="visibleTabs['therapy']" [class.active]="activeTab === 'therapy'"
                    (click)="switchTab('therapy', 'nav-therapy')" role="tab" aria-selected="false">
                    <i class="fas fa-prescription-bottle-alt fa-3x d-block"></i><span
                        class="d-none d-sm-block">Therapy</span>
                </a>
                <a class="nav-item nav-link" *ngIf="visibleTabs['prescriptions']" [class.active]="activeTab === 'prescriptions'"
                    (click)="switchTab('prescriptions', 'nav-prescriptions')" role="tab" aria-selected="false">
                    <i class="fas fa-prescription-bottle-alt fa-3x d-block"></i><span
                        class="d-none d-sm-block">Prescriptions</span>
                </a>
            </div>
        </nav>
        <div class="tab-content py-3 px-3 px-sm-0" id="nav-tabContent">
            <div class="tab-pane fade show active" role="tabpanel">
                <div [innerHTML]="currentBonusServiceHtml"></div>
            </div> 
        </div>